// import { cn } from "@/lib/utils";


const StatusBadge = ({ status, className }) => {
  const badgeStyles = {
    regular: "bg-blue-50 text-blue-800",
    vip: "bg-blue-100 text-blue-800",
    vvip: "bg-blue-150 text-blue-800",
    vvvip: "bg-blue-200 text-blue-800",
  };

  const displayText = {
    regular: "Regular",
    vip: "VIP",
    vvip: "VVIP",
    vvvip: "VVVIP"
  };

  return (
    <span 
      className={`
        inline-flex items-center ml-4 px-4 py-2 rounded-full text-[12px] font-medium
        ${badgeStyles[status.toLowerCase()]}
        ${className}
      `}
    >
      {displayText[status.toLowerCase()]}
    </span>
  );
};

export default StatusBadge;